module.exports = __webpack_public_path__ + "img/mada.2c263506.svg";